module.exports = __webpack_public_path__ + "img/ico-facebook.fd95011b.svg";